import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Popup, Button, Select, Radio } from "semantic-ui-react";
import { FaRuler, FaVectorSquare, FaPhotoVideo } from "react-icons/fa";
import { BsArrowsFullscreen, BsArrowClockwise } from "react-icons/bs";
import { BiTargetLock, BiCopy } from "react-icons/bi";

//import { MdLocalPrintshop } from "react-icons/md";
import { IoIosInformationCircle, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import Geolocation from "ol/Geolocation";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { Circle as CircleStyle, Fill, Stroke, Style, Icon } from "ol/style";

import { transform } from "ol/proj";
import { getCenter } from "ol/extent";


import SisTree from "store/sis/SisTree";
import SisOverlay from "store/sis/SisOverlay";

import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";


import css from "./mapMenu.module.scss";

class mapMenu extends Component {
    state = {
        activeItem: "",
        activeMap: "map1",
        mapSplit: "one",
        infoChecked: false,
        mobileToolsOpen: false,
    };

   

    positionFeature = "";
    accuracyFeature = "";
    styleFeature = "";
    geolocation = "";

    isMyPos = false;

    mapMenuHandlerClear = () => {
        const { sisMeasure, sisCreator } = this.props.sis;

        sisMeasure.stopMeasure();
        sisCreator.stop();
        //this.stopLayerInformation(); // 정보보기 중지
    };

    // 내위치 공유
    positionCopy = () => {
        const { sisMap } = this.props.sis;

        const coord = sisMap.view.getCenter();
        const zoom = sisMap.view.getZoom();

        let url = window.location.origin + "/mapMain/" + coord[0] + "/" + coord[1] + "/" + zoom;

        const t = document.createElement("textarea");
        document.body.appendChild(t);
        t.value = url;
        t.select();
        document.execCommand("copy");
        document.body.removeChild(t);

        alert("내 위치 URL 복사완료\r\n" + url);
    };

    // 내위치
    getPosition = () => {
        const { sisLayer, sisMap } = this.props.sis;

        $(`#${css.myPos}`).toggleClass(css.active);

        // if (!this.geolocation) {
        this.geolocation = new Geolocation({
            // enableHighAccuracy must be set to true to have the heading value.
            tracking: true.valueOf,
            trackingOptions: {
                enableHighAccuracy: true,
                maximumAge: 500,
            },
            projection: sisMap.view.getProjection(),
        });
        // }

        const lyr = sisLayer.wfs.myPosLayer;
        const source = lyr.getSource();

        if ($(`#${css.myPos}`).hasClass(css.active)) {
            $("#loader").show();

            navigator.geolocation.getCurrentPosition(this.successCallback, this.errorCallback);

            this.geolocation.setTracking(true);

            this.accuracyFeature = new Feature();
            this.styleFeature = new Feature();
            this.positionFeature = new Feature();

            this.accuracyFeature.setStyle(
                new Style({
                    image: new CircleStyle({
                        radius: 25,
                        fill: new Fill({
                            color: "rgb(64, 98, 187, 0.5)",
                        }),
                        stroke: new Stroke({
                            color: "#4062bb",
                        }),
                    }),
                })
            );

            this.styleFeature.setStyle(
                new Style({
                    image: new CircleStyle({
                        radius: 11,
                        stroke: new Stroke({
                            color: "rgba(255,0,0,1)",
                        }),
                        fill: new Fill({
                            color: "rgba(255,255,255, 0.8)",
                        }),
                    }),
                })
            );

            this.positionFeature.setStyle(
                new Style({
                    image: new CircleStyle({
                        radius: 7,
                        fill: new Fill({
                            color: "rgba(255,0,0,1)",
                        }),
                    }),
                    // image: new Icon({
                    // 	anchor: [32, 52],
                    // 	anchorXUnits: "pixels",
                    // 	anchorYUnits: "pixels",
                    // 	opacity: 1,
                    // 	scale: 1,
                    // 	src: "/sis/images/map/gps.png",
                    // }),
                })
            );

            source.clear();
            source.addFeature(this.accuracyFeature);
            source.addFeature(this.styleFeature);
            source.addFeature(this.positionFeature);

            var user = navigator.userAgent;
            var isMobile = false;
            if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1 || user.indexOf("iPad") > -1 || user.indexOf("iPod") > -1) {
                isMobile = true;
            }

            if (navigator.geolocation) {
                if (isMobile) {
                    this.geolocation.un("change", this.changePosition);
                    this.geolocation.on("change", this.changePosition);

                    // this.geolocation.un("change:accuracyGeometry", this.accurayChange);
                    // this.geolocation.on("change:accuracyGeometry", this.accurayChange);

                    this.geolocation.un("change:position", this.changePosition);
                    this.geolocation.on("change:position", this.changePosition);
                } else {
                    // this.getPosition();
                }
            } else {
                console.log("Browser doesn't support Geolocation or doesn't connect by HTTPS");
            }
        } else {
            source.clear();
            this.geolocation.setTracking(false);

            this.geolocation.un("change", this.changePosition);
            this.geolocation.un("change:position", this.changePosition);
        }
    };

    successCallback = (position) => {
        const { sisMap } = this.props.sis;

        let pos = { lat: position.coords.latitude, lng: position.coords.longitude, heading: position.coords.heading };

        var coord = transform([pos.lng, pos.lat], "EPSG:4326", sisMap.view.getProjection().getCode());
        sisMap.view.setCenter(coord);
        sisMap.view.setZoom(9);

        var user = navigator.userAgent;
        if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1 || user.indexOf("iPad") > -1 || user.indexOf("iPod") > -1) {
            this.positionFeature.setGeometry(new Point(coord));
            this.accuracyFeature.setGeometry(new Point(coord));
            this.styleFeature.setGeometry(new Point(coord));
            // if (pos.heading) this.positionFeature.getStyle().getImage().setRotation(pos.heading);
        } else {
            this.positionFeature.setGeometry(new Point(coord));
            this.accuracyFeature.setGeometry(new Point(coord));
            this.styleFeature.setGeometry(new Point(coord));
            // this.positionFeature.getStyle().getImage().setRotation(pos.heading);
        }

        if (this.isMyPos) {
            this.positionCopy();
            this.isMyPos = false;
        }

        $("#loader").hide();
    };

    errorCallback = (error) => {
        $("#loader").hide();
        alert("설정에서 위치정보 사용을 승인 후 다시 시도해주세요.");
        // alert(error.message);
        console.log(error.message);
        $(`#${css.myPos}`).removeClass(css.active);
    };

    change = () => {
        const { sisMap } = this.props.sis;

        var coordinates = this.geolocation.getPosition();
        sisMap.view.setCenter(coordinates);
    };

    changePosition = () => {
        const { sisMap } = this.props.sis;

        const coordinates = this.geolocation.getPosition();
        this.positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
        this.accuracyFeature.setGeometry(coordinates ? new Point(coordinates) : null);
        this.styleFeature.setGeometry(coordinates ? new Point(coordinates) : null);

        const heading = this.geolocation.getHeading();

        // if (heading) this.positionFeature.getStyle().getImage().setRotation(this.geolocation.getHeading());

        if ($(`#${css.myPos}`).hasClass(css.active)) {
            sisMap.view.setCenter(coordinates);
        }
    };

    accurayChange = (evt) => {
        this.accuracyFeature.setGeometry(evt.target.getAccuracyGeometry());
    };

    handleItemClick = (evt) => {
        const { sisMeasure, sisMap, sisLayer, sisCreator } = this.props.sis;
        const id = evt.target.closest("button").id;

        if (this.state.roadViewMode) {
            alert("로드뷰를 종료하고 사용하여 주세요.");
            return;
        }

        this.setState({ activeItem: "" });
        this.mapMenuHandlerClear();

        switch (id) {
            case css.distance:
                this.setState({
                    activeItem: id,
                });
                sisMeasure.startMeasure("LineString");
                break;
            case css.area:
                this.setState({
                    activeItem: id,
                });
                sisMeasure.startMeasure("Polygon");
                break;
            case css.refresh:
                sisLayer.clear();
                sisMeasure._allClear();
                sisCreator.clear();

                $("#searchOverlayWrap").hide();
                $("#searchOverlayTitle").text("");

                this.stopLayerInformation(); // 정보보기 중지

                break;
            case css.fullScreen:
                sisMap.fullExtent();
                return;
            case css.save:
                sisMap.mapExport();
                return;
            case css.print:
                $(".sisModalWrap").hide();
                $(this.props.layout.get("mapPrint")).show();
                return;
            case css.draw:
                $(".sisModalWrap").hide();
                $("#drawShapes").show();
                break;
            case css.memo:
                this.viewMemo(evt);
                return;
            case css.information:
                const target = $(evt.target).closest("button");
                target.toggleClass(css.active);
                // console.log(target.hasClass(css.active));

                if (target.hasClass(css.active)) {
                    this.startLayerInformation();
                } else {
                    this.stopLayerInformation(); // 정보보기 중지
                }

                //const layout = this.props.layout;
                //const modal = layout.get("mapInfoModal");

                //modal.show();
                break;
            default:
                return;
        }
    };

    baseMapHanlder = (evt) => {
        const { sisMap } = this.props.sis;

        if ($(evt.target).hasClass(css.active)) {
            $(evt.target).removeClass(css.active).removeClass("active");
            sisMap.kakaoNone();
          // $("#airphoto input[value=-]")[0].click();

            return;
        }

        $("." + css.selectMapWrap + " div")
            .removeClass(css.active)
            .removeClass("active");
        $(evt.target).addClass(css.active).addClass("active");

        if (evt.target.id === css.base) {
            sisMap.kakaoNormal();
           // $("#airphoto input[value=-]")[0].click();
          // sisMap.vworldNormal();
        } else {
            sisMap.kakaoHybrid();
            //$("#airphoto input[value=2023]")[0].click();
            //$("#airphoto input[value=-]")[0].click();
        }
    };

    setMapZoom = (evt, { value }) => {
        this.props.sis.sisMap.view.setZoom(value);
    };

    // 사진메모 보기
    viewMemo = (evt) => {
        const { sisLayer, sisMap } = this.props.sis;

        const target = evt.target.closest("button");
        // console.log("dd");

        $(target).toggleClass(css.active);

        if ($(target).hasClass(css.active)) {
            this.loadMemo();
            sisMap.map.on("click", this.memoClick);
        } else {
            sisLayer.wfs.memoLayer.setVisible(false);

            sisMap.map.un("click", this.memoClick);
        }
    };

    // 사진메모 로드
    loadMemo = () => {
        const { sisLayer, sisMap } = this.props.sis;

        $.ajax({
            url: "/map/selectMemo",
            type: "post",
            success: (res) => {
                const lyr = sisLayer.getLayerByID("memoLayer");

                if (!lyr) {
                    sisLayer.wfs.memoLayer = sisLayer.addVectorLayer("memoLayer");
                }

                sisLayer.wfs.memoLayer.setVisible(true);
                sisLayer.wfs.memoLayer.setStyle(null);
                const source = sisLayer.wfs.memoLayer.getSource();

                if (res.length > 0) {
                    res.forEach((item, idx) => {
                        const x = parseFloat(item.centX);
                        const y = parseFloat(item.centY);

                        const feature = sisLayer.createPointFeature(transform([x, y], "EPSG:5186", "EPSG:5181"));
                        feature.setProperties(item);
                        feature.setStyle(sisLayer.createPointFeatureStyle(5, "red"));
                        source.addFeature(feature);
                    });
                }
            },
        });
    };

    // 사진메모 선택
    memoClick = (evt) => {
        const { sisMap } = this.props.sis;
        const features = evt.map.getFeaturesAtPixel(evt.pixel);

        if (features.length > 0) {
            const feature = features[0];
            const coord = feature.getGeometry().getCoordinates();
            const files = feature.get("files");
            const content = feature.get("memoContent");

            let viewOverlay = null;

            if (!this.state.viewOverlay) {
                viewOverlay = new SisOverlay(".viewOverlay", sisMap.map, "bottom-left", [-40, -10]);

                this.setState({
                    viewOverlay,
                });

                sisMap.map.addOverlay(viewOverlay);
                sisMap.view.setCenter(coord);
            } else {
                viewOverlay = this.state.viewOverlay;
            }

            sisMap.view.setCenter(coord);
            sisMap.view.setZoom(10);
            viewOverlay.setPosition(coord);

            let arrFiles = [];

            if (files) {
                arrFiles = files.split(",");

                arrFiles.forEach((f) => {
                    $(".imageWrap").append("<a href='/map/memoDownload?type=mapMemo&fileName=" + encodeURI(encodeURIComponent(f)) + "'>" + f + "</a>");
                });
            }

            $(".viewOverlay textarea").val(content);
            $(".viewOverlay").show();
            $(`#${this.props.id}`).hide();
        }
    };

    // 화면 분할
    mapSplit = (evt, seleted) => {
        const { sisMap, sisTree } = this.props.sis;
        sisMap._addDaumClear();

        // if (this.state.roadViewMode) {
        // 	alert("로드뷰를 종료하고 사용하여 주세요.");
        // 	return;
        // }

        sisTree.treeList = [];
        const disableSetting = true;

        $(".mapNumber").show();
        $(".subTreeWrap").hide();
        $("#treeMapSelectWrap").show();
        $("#treeMapSelectWrap button").hide();
        $("#treeMapSelectWrap button:first-child").click();

        // $(".subTree").html("");

        switch (seleted.value) {
            case "two":
                sisMap.createSubMap(2);

                $("#treeMapSelectWrap #map1").show();
                $("#treeMapSelectWrap #map2").show();

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree2",
                        map: sisMap.subMap[0],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                // console.log(sisTree);

                break;
            case "three":
                sisMap.createSubMap(3);

                $("#treeMapSelectWrap #map1").show();
                $("#treeMapSelectWrap #map2").show();
                $("#treeMapSelectWrap #map3").show();

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree2",
                        map: sisMap.subMap[0],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree3",
                        map: sisMap.subMap[1],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                break;
            case "four":
                sisMap.createSubMap(4);

                $("#treeMapSelectWrap button").show();
                $("#subMap3").css({
                    left: "0",
                });

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree2",
                        map: sisMap.subMap[0],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree3",
                        map: sisMap.subMap[1],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                sisTree.treeList.push(
                    new SisTree({
                        id: "tree4",
                        map: sisMap.subMap[2],
                        url: "/map/getAllLayers",
                        isSubTree: true,
                        legend: true,
                        rootType: "dropdown",
                        disableSetting,
                    })
                );

                break;
            default:
                $("#treeMapSelectWrap").hide();
                $(".mapNumber").hide();
                sisMap.subMapClear();
        }

        this.setState({
            mapSplit: seleted.value,
        });
        sisMap._addDaumHybrid();
    };

    roadView = (evt) => {
        //alert("준비중입니다");
        //return;
        const { sisMap } = this.props.sis;

        this.mapSplit(null, { value: "-" }); // 화면분할 종료
        this.stopLayerInformation(); // 정보보기 중지
        this.mapMenuHandlerClear();

        $(evt.target).closest("button").toggleClass(css.active);

        const visible = sisMap.daumRoadView.getVisible();

        sisMap.daumRoadView.setVisible(!visible);

        if (!visible) {
            var roadviewContainer = document.getElementById("roadViewWrap"); //로드뷰를 표시할 div
            sisMap.roadViewInit(roadviewContainer);

            this.setState({
                roadViewMode: true,
                mapSplit: "one",
            });
           
            $('.roadViewClose').off("click").on("click", () => {
                this.closeRoadView();
            });
            
        } else {
            this.closeRoadView();

            this.setState({
                roadViewMode: false,
                mapSplit: "one",
            });
            
        }
    };
    
    // 로드뷰 닫기
    closeRoadView = () => {
        $('.roadViewClose').hide();
        var roadviewContainer = document.getElementById("roadViewWrap");

        $(`.roadViewHidden, .footer`).show();
        $(`.ol-overlaycontainer-stopevent`).show();
        if ($(".toggle").hasClass("close")) $(".toggle").click();
        $("#mapNumber").show();

        $(".sisMapWrap").css({
            top: "64px",
            left: "384px",
            width: "auto",
            height: "auto",
            zIndex: "auto",
            bottom: 0,
            right: 0,
            // display: "inline-flex",
            border: "0",
            transition: "left 0.15s linear",
        });
        $("#map").css({ border: "0" });

        $(".mapRight.menu").show();
        // }

        $(".sisResizable").hide();
        $(".currentArea").show();
        // $(roadviewContainer).hide();

        this.props.sis.sisMap.closeRoadView(roadviewContainer, true);
    };

    // 항공영상 선택
    airphotoChange = (e, value) => {
        const { sisTree, sisMap } = this.props.sis;
        const { activeMap } = this.state;

        let target;
        let targetNum = 1;

        if (!$(`#${css.air}`).hasClass(css.active) && value !== "-") {
            $(`#${css.air}`).addClass(css.active);
            sisMap.kakaoHybrid();
        }

        switch (activeMap) {
            case "map1":
                target = sisTree.layers;
                targetNum = 1;
                break;
            case "map2":
                target = sisTree.treeList[0].layers;
                targetNum = 2;
                break;
            case "map3":
                target = sisTree.treeList[1].layers;
                targetNum = 3;
                break;
            case "map4":
                target = sisTree.treeList[2].layers;
                targetNum = 4;
                break;
            default:
                break;
        }

        $.each(target, (idx, lyr) => {
            const id = lyr.get("id");

            if (id.indexOf("airphoto") > -1) {
                lyr.setVisible(false);

                if (value === "2009") {
                    if (id.indexOf(`airphoto_2008_2009`) > -1) {
                        lyr.setVisible(true);
                    }
                } else if (value === "2015") {
                    if (id.indexOf(`airphoto2014`) > -1 || id.indexOf(`airphoto2015`) > -1) {
                        lyr.setVisible(true);
                    }
                } else {
                    if (id.indexOf(`airphoto${value}`) > -1) {
                        lyr.setVisible(true);
                    }
                }
            }
        });

        $(`#mapNum${targetNum}`).text(`영상${targetNum} (${value !== "-" ? value + "년" : "없음"})`);

        // console.log(sisLayer.wmts[`airphoto${value}`]);
    };

    // 정보보기 이벤트
    startLayerInformation = () => {
        const { sisMap } = this.props.sis;

        //if (!this.overlay) this.overlay = new SisOverlay("#lyrPropsOverlayWrap", sisMap.map, "top-left", [20, -30]);
        //if (!this.listOverlay) this.listOverlay = new SisOverlay("#lyrPropsListOverlayWrap", sisMap.map, "top-left", [20, -30]);

        sisMap.map.on("click", this._getLayerInformation);
    };

    // 정보보기 이벤트 중지
    stopLayerInformation = () => {
        const { sisMap, sisLayer } = this.props.sis;

        $(`.${css.menuWrap} button:not(.${css.btnRoadview})`).removeClass(css.active); //버튼 active 초기화

        sisLayer.wfs.selectLayer.getSource().clear();

        sisMap.map.un("click", this._getLayerInformation);
    };

    // 정보보기 지도 클릭 이벤트
    _getLayerInformation = (evt) => {
        const coordinate = evt.coordinate;

        const layout = this.props.layout;
        const modal = layout.get("mapInfoModal");

        modal.show(coordinate);
    };

    getFeatureProps = (feature, korName) => {
        const { sisMap, sisLayer } = this.props.sis;

        const oriId = feature.getId();
        const split = oriId.split(".");
        const id = split[1];
        const tableName = split[0];

        $.ajax({
            url: "/map/getFeatureInfo",
            type: "post",
            data: {
                tableName,
                id,
            },
            success: (res) => {
                // console.log(res);

                if (res) {
                    const item = res.item;
                    const wkt = item.wkt;
                    const columns = res.columns;

                    const table = (
                        <table>
                            <caption>정보보기</caption>
                            <tbody>
                            {columns.map((col, idx) => {
                                if (col.engName !== "geom")
                                    return (
                                        <tr key={idx}>
                                            <th>{col.korName}</th>
                                            <td>{item[col.engName] ? item[col.engName] : "-"}</td>
                                        </tr>
                                    );
                            })}
                            </tbody>
                        </table>
                    );

                    const f = sisLayer.createFeatureByWKT(wkt);
                    const geometry = f.getGeometry();
                    const type = geometry.getType();

                    geometry.transform("EPSG:5186", sisMap.crsCode);

                    sisLayer.wfs.selectLayer.getSource().addFeature(f);
                    let coord = [];

                    const extent = geometry.getExtent();
                    coord = getCenter(extent, 2);
                    sisMap.view.fit(extent);

                    if (type === "Point") {
                        sisMap.view.setZoom(11);
                    }

                    this.overlay.setPosition(coord);
                    this.listOverlay.setPosition(coord);

                    $("#lyrPropsTitle").text(`${korName} (${id})`);
                    $("#lyrPropsOverlayWrap").show();

                    this.setState({
                        lyrProps: table,
                    });
                }
            },
        });
    };

    // 정보보기 클릭 이벤트 초기화
    removePropsSelect = () => {
        const { sisLayer } = this.props.sis;

        sisLayer.wfs.selectLayer.getSource().clear();
        $("#lyrPropsListItemWrap").html("");
        $("#lyrPropsOverlayWrap").hide();
        $("#lyrPropsListOverlayWrap").hide();
    };

    // 정보보기 레이어 리스트 닫기
    lyrPropsListClose = () => {
        this.props.sis.sisLayer.wfs.selectLayer.getSource().clear();
        $("#lyrPropsListOverlayWrap").hide();
    };

    // 정보보기 팝업 닫기
    lyrPropsClose = () => {
        this.props.sis.sisLayer.wfs.selectLayer.getSource().clear();
        $("#lyrPropsOverlayWrap").hide();
    };

    selectTree = (evt) => {
        const id = evt.target.id;

        $(".tree, .airphoto").hide();
        $(`#${css.treeWrap} button`).removeClass(css.active);
        $(evt.target).addClass(css.active);

        if (id === "map1") {
            $("#tree").show();
            $("#airphoto").show();
        } else if (id === "map2") {
            $("#tree2").show();
            $("#airphoto2").show();
        } else if (id === "map3") {
            $("#tree3").show();
            $("#airphoto3").show();
        } else if (id === "map4") {
            $("#tree4").show();
            $("#airphoto4").show();
        }

        this.setState({
            activeMap: id,
        });
    };

    handleInfoChange = (event) => {
        const { checked } = event.target;
        this.setState({ infoChecked: checked });
        const currentSisMapInstance = window.sis;
        if (currentSisMapInstance) {
            currentSisMapInstance.setDaumHybridvisibleCheck(checked);
        } else {
            alert('지도 정보를 없애는데 실패했습니다.')
        }
    };


    toggleMobileTools = () => {
        this.setState((prevState) => ({
            mobileToolsOpen: !prevState.mobileToolsOpen,
        }));
    };

    render() {
        // const { activeItem } = this.state;
        const { infoChecked, mobileToolsOpen } = this.state;
        return (
            <>
                <button
                    type="button"
                    className={`${css.mobileToolToggle} ${mobileToolsOpen ? css.active : ""}`}
                    onClick={this.toggleMobileTools}
                    aria-expanded={mobileToolsOpen}
                    aria-controls="responsiveMapTools"
                >
                    <span className={css.mobileToolIcon} aria-hidden="true">☰</span>
                    <span className={css.mobileToolText}>지도도구</span>
                </button>

                <div
                    id="responsiveMapTools"
                    className={`${css.mapMenuWrap} ${mobileToolsOpen ? css.mobileOpen : ""}`}
                >
                    <div className={css.menuWrap}>
                        {/*  <Popup
                            trigger={
                                <Button id={css.fullScreen} className="btnFullScreen" icon primary
                                        onClick={this.handleItemClick}>
                                    <BsArrowsFullscreen size="25px"/>
                                    <span>전체보기</span>
                                </Button>
                            }
                            content="전체화면"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />*/}
                     
                        <Popup
							trigger={
                                <Button id={css.print} icon primary className='printSave' onClick={this.handleItemClick}>
									{/*<MdLocalPrintshop size="25px" />*/}
									<span>저장/출력</span>
								</Button>
							}
							content="저장 및 출력"
							position="bottom center"
							on="hover"
							size="small"
							inverted
						/>
                        <div className={css.menuWrap}>
                        <Popup
                            trigger={
                                <Button id={css.distance} icon primary className='distanceMeasure' onClick={this.handleItemClick}>
                                    {/*<FaRuler size="25px"/>*/}
                                    <span>거리측정</span>
                                </Button>
                            }
                            content="거리측정"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />
                         <Popup
                            trigger={
                                <Button id={css.area} icon primary className='areaMeasure' onClick={this.handleItemClick}>
                                    {/* <FaVectorSquare size="20px"/>*/}
                                    <span>
										면적측정
									</span>
                                </Button>
                            }
                            content="면적측정"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />
                       
                    </div>
						{/*<Popup
							trigger={
								<Button id={css.memo} className='mapMamo' icon primary onClick={this.handleItemClick}>
									
									<span>
										사진메모
									</span>
								</Button>
							}
							content="사진메모"
							position="bottom center"
							on="hover"
							size="small"
							inverted
						/>*/}
                     <Popup
                            trigger={
                                <Button id={css.refresh} icon primary className='mapRefresh' onClick={this.handleItemClick}>
                                    {/*<BsArrowClockwise size="25px"/>*/}
                                    <span>새로고침</span>
                                </Button>
                            }
                            content="지도 새로고침"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        /> 

                        <Popup
                            trigger={
                                <Button id={css.information} icon primary className='mapInformation' onClick={this.handleItemClick}>
                                    {/*<IoIosInformationCircle size="25px"/>*/}
                                    <span>정보보기</span>
                                </Button>
                            }
                            content="정보보기"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />
                        {/*<Popup
                            trigger={
                                <Button id={css.draw} color="twitter" icon onClick={this.handleItemClick}>
                                    {/* <FaRuler size="25px" /> 
                                    <img
                                        src="/sis/images/map/draw.png"
                                        alt="도형그리기"
                                        style={{
                                            display: "block",
                                            margin: "0 auto",
                                            marginBottom: "2px",
                                            marginTop: "3px",
                                        }}
                                    />
                                    <span>도형그리기</span>
                                </Button>
                            }
                            content="도형그리기"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />*/}

                        {/* <Popup
                            trigger={
                                <Button id={css.memo} color="twitter" icon onClick={this.handleItemClick}>
                                    <FaPhotoVideo size="22px"/>
                                    <span
                                        style={{
                                            display: "block",
                                            marginBottom: "-3px",
                                        }}
                                    >
										사진/
									</span>
                                    <span>동영상</span>
                                </Button>
                            }
                            content="사진/동영상"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />*/}
                    </div>

                    {/*<Select
                        className={css.dropdown}
                        style={{minWidth: "120px", zIndex: 999}}
                        value={this.state.mapSplit}
                        options={[
                            {
                                key: "one",
                                value: "one",
                                text: "분할없음",
                            },
                            {
                                key: "two",
                                value: "two",
                                text: "2분할",
                            },
                            //{
                            //	key: "three",
                            //	value: "three",
                            //	text: "3분할",
                            //},
                            {
                                key: "four",
                                value: "four",
                                text: "4분할",
                            },
                        ]}
                        onChange={this.mapSplit}
                    />*/}

                    <div className={`${css.selectMapWrap}`}>
                        <div id={css.base} className={`${css.active}`}
                         onClick={this.baseMapHanlder} >
                            일반
                        </div>
                        <div id={css.air} className={`${this.state.btnAir}`}
                             onClick={this.baseMapHanlder}>
                            {" "}
                            위성{" "}
                        </div>
                    </div>

                    <div className={css.menuWrap}>
                        <Popup
                            trigger={
                                <Button className={`${css.white} ${css.btnRoadview} btnRoadView`} icon
                                        onClick={this.roadView}>
                                    <span>로드뷰</span>
                                </Button>
                            }
                            content="로드뷰"
                            position="bottom center"
                            on="hover"
                            size="small"
                            inverted
                        />
                        {/* <Popup
							trigger={
								<Button className={css.white} icon>
									<AiFillStar size="25px" />
									<span>즐겨찾기</span>
								</Button>
							}
							content="즐겨찾기"
							position="bottom center"
							on="hover"
							size="small"
							inverted
						/> */}
                    </div>
                </div>

                {/*<Popup
                    trigger={
                        <div id={css.myPos} className="myPos" onClick={this.getPosition}>
                            <BiTargetLock size="25px"/>
                        </div>
                    }
                    content="내위치"
                    position="left center"
                    on="hover"
                    size="small"
                    inverted
                />

                <Popup
                    trigger={
                        <div id={css.myPosCopy} className="myPosCopy" onClick={this.positionCopy}>
                            <BiCopy size="25px"/>
                        </div>
                    }
                    content="공유하기"
                    position="left center"
                    on="hover"
                    size="small"
                    inverted
                />*/}

                <div id="mapScaleWrap" className={`${css.mapScaleWrap} roadviewHidden mapScaleWrap`}>
                    <span className={css.title}>축척</span>
                    <label htmlFor="ol-scale" style={{ display: 'none' }}>축적</label>
                    <Select
                        id="ol-scale"
                        className={css.selectScale}
                        defaultValue={"3"}
                        options={[
                            // {
                            // 	key: "14",
                            // 	value: "14",
                            // 	text: "1:119",
                            // },
                            // {
                            // 	key: "13",
                            // 	value: "13",
                            // 	text: "1:237",
                            // },
                            // {
                            // 	key: "12",
                            // 	value: "12",
                            // 	text: "10m",
                            // },
                            // {
                            // 	key: "11",
                            // 	value: "11",
                            // 	text: "10m",
                            // },
                            {
                                key: "10",
                                value: "10",
                                text: "20m",
                            },
                            {
                                key: "9",
                                value: "9",
                                text: "30m",
                            },
                            {
                                key: "8",
                                value: "8",
                                text: "50m",
                            },
                            {
                                key: "7",
                                value: "7",
                                text: "100m",
                            },
                            {
                                key: "6",
                                value: "6",
                                text: "250m",
                            },
                            {
                                key: "5",
                                value: "5",
                                text: "500m",
                            },
                            {
                                key: "4",
                                value: "4",
                                text: "1km",
                            },
                            {
                                key: "3",
                                value: "3",
                                text: "2km",
                            },
                            {
                                key: "2",
                                value: "2",
                                text: "4km",
                            },
                            {
                                key: "1",
                                value: "1",
                                text: "8km",
                            },
                            {
                                key: "0",
                                value: "0",
                                text: "16km",
                            },
                        ]}
                        onChange={this.setMapZoom}
                    />
                </div>
                <div id={css.infoLayer}>
                    <label>
                    <input
                        id={css.infoCheckBox}
                        type="checkbox"
                        checked={infoChecked}
                        onChange={this.handleInfoChange}
                    />
                    </label>
                    <label id={css.infoLabel} htmlFor={css.infoCheckBox}>지도 정보</label>
                </div>
                <div
                    id={css.layerManager}
                    onClick={() => {
                        $("." + css.treeWrap).toggle();
                    }}
                >
                    레이어
                </div>
                <div id={css.treeWrap} className={`${css.treeWrap} layerOpen`}>
                    <div
                        id="treeMapSelectWrap"
                        style={{
                            padding: "10px",
                            textAlign: "left",
                            display: "none",
                        }}
                    >
                        <Button id="map1" className={css.active} onClick={this.selectTree}>
                            영상1
                        </Button>
                        <Button id="map2" onClick={this.selectTree}>
                            영상2
                        </Button>
                        <Button id="map3" onClick={this.selectTree}>
                            영상3
                        </Button>
                        <Button id="map4" onClick={this.selectTree}>
                            영상4
                        </Button>
                    </div>

                    {/*<div id={css.airphotoWrap}>
                        <div
                            className={css.titleWrap}
                            onClick={(e) => {
                                $(`#${css.airphotoWrap} .${css.itemsWrap}`).slideToggle("fast");
                                $(e.target).closest(`.${css.titleWrap}`).toggleClass(css.dropdown);
                                $(`#${css.airphotoWrap} .${css.titleWrap} svg`).toggle();
                            }}
                        >
                            <span>전라남도 항공영상</span>
                            <div>
                                <IoIosArrowDown className={css.on}/>
                                <IoIosArrowUp className={css.off}/>
                            </div>
                        </div>

                        <div className={css.itemsWrap}>
                            <SelectAirPhoto id="airphoto" onChange={this.airphotoChange}/>
                            <SelectAirPhoto id="airphoto2" style={{display: "none"}} onChange={this.airphotoChange}/>
                            <SelectAirPhoto id="airphoto3" style={{display: "none"}} onChange={this.airphotoChange}/>
                            <SelectAirPhoto id="airphoto4" style={{display: "none"}} onChange={this.airphotoChange}/>
                        </div>
                    </div>*/}

                    <div id="tree" className="tree"></div>
                    <div id="tree2" className="tree"></div>
                    <div id="tree3" className="tree"></div>
                    <div id="tree4" className="tree"></div>

                    <div id={css.searchResultWrap}>
                        <div
                            className={css.titleWrap}
                            onClick={(e) => {
                                $(`#${css.searchResultWrap} .itemsWrap`).slideToggle("fast");
                                $(e.target).closest(`.${css.titleWrap}`).toggleClass(css.dropdown);
                                $(`#${css.searchResultWrap} .${css.titleWrap} svg`).toggle();
                            }}
                        >
                            <span>조회결과 리스트</span>
                            <div>
                                <IoIosArrowDown className={css.on} />
                                <IoIosArrowUp className={css.off} />
                            </div>
                        </div>

                        <div id="treeResultWrap" className="itemsWrap"></div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(
    (state) => ({
        sis: state.sisMap,
        sisMeasure: state.sisMeasure,
        layout: state.layout,
    }),
    (dispatch) => ({
        SisMapActions: bindActionCreators(sisMapActions, dispatch),
        
    })
)(mapMenu);

class SelectAirPhoto extends Component {
    state = {
        value: "2023",
    };

    handleChange = (e, { value }) => {
        this.setState({ value });

        if (this.props.onChange) this.props.onChange(e, value);
    };

    render() {
        // const { css } = this.props;

        return (
            <div id={this.props.id} className="airphoto" style={this.props.style}>
                <Radio className={css.radio} style={{ display: "none" }} label="없음" name={this.props.name} value="-"
                    checked={this.state.value === "-"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2003년" name={this.props.name} value="2003"
                    checked={this.state.value === "2003"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2009년" name={this.props.name} value="2009"
                    checked={this.state.value === "2009"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2011년" name={this.props.name} value="2011"
                    checked={this.state.value === "2011"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2013년" name={this.props.name} value="2013"
                    checked={this.state.value === "2013"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2015년" name={this.props.name} value="2015"
                    checked={this.state.value === "2015"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2017년" name={this.props.name} value="2017"
                    checked={this.state.value === "2017"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2019년" name={this.props.name} value="2019"
                    checked={this.state.value === "2019"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2021년" name={this.props.name} value="2021"
                    checked={this.state.value === "2021"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2022년" name={this.props.name} value="2022"
                    checked={this.state.value === "2022"} onChange={this.handleChange} />
                <Radio className={css.radio} label="2023년" name={this.props.name} value="2023"
                    checked={this.state.value === "2023"} onChange={this.handleChange} />
            </div>
        );
    }
}
